import api from "@/config/apiConfig"

class BancosController {
  async index() {
    const response = await api.get("/banks");
    return response.data;
  }

  async create(req) {
    const response = await api.post("/banks", req);
    return response.data;
  }

  async update(req) {
    const response = await api.put(`/banks/${req.id}`, req);
    return response.data;
  }

  async reactivate(id) {
    const response = await api.post(`/banks/${id}/reactivate`);
    return response.data;
  }

  async delete(id) {
    const response = await api.delete(`/banks/${id}`);
    return response.data;
  }

  async deleteCertificate(id) {
    const response = await api.delete(`/banks/${id}/certificate`);
    return response.data;
  }

  async deleteKeyFile(id) {
    const response = await api.delete(`/banks/${id}/key-file`);
    return response.data;
  }

  async uploadCertificate(id, file) {
    const formData = new FormData();
    formData.append("file", file);
    const response = await api.post(`/banks/${id}/certificate`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }

  async uploadKeyFile(id, file) {
    const formData = new FormData();
    formData.append("file", file);
    const response = await api.post(`/banks/${id}/key-file`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }
}

export default new BancosController();
